import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserAuthService } from 'src/app/modules/auth/services/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private userAuthService: UserAuthService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Get the auth token from the service.
        const authToken = this.userAuthService.accessToken;

        if (!req.headers.has('Authorization')) {
            req = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + authToken)
            });
        }

        // send cloned request with header to the next handler.
        return next.handle(req);
    }
}
